export enum ProfileActionTypes {
  GET__PROFILE_REQUEST = '[Profile] GET__PROFILE_REQUEST',
  GET__PROFILE_SUCCESS = '[Profile] GET__PROFILE_SUCCESS',
  GET__PROFILE_ERROR = '[Profile] GET__PROFILE_ERROR',
}
